import { getCallSessionAgentUserId } from "../api";
import { callAPi } from "../CallService";
import {
  getAgentPhoneForCalling,
  getAgentPhoneForCallingKrmId
} from "../helpers";

export const getApiParams = (callFlow, agent) => {
  return {
    uuid: callFlow.state.agentAnswerEvent["unique_id"],
    number: getAgentPhoneForCalling(agent), //+918860077390, (Leg C number)
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: callFlow.ticker.eventsMap["CUSTOMER_ANSWER"]["unique_id"] + "@@c2c",
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };
};

export const getApiParamsHold = (callFlow, agent) => {
  if (callFlow.state.call_type === "legc_call") {
    return getApiParamsLegCHold(callFlow, agent);
  } else {
    return getApiParamsLegBHold(callFlow, agent);
  }
};
export const getApiParamsLegBHold = (callFlow, agent) => {
  return {
    uuid: callFlow.state.agentAnswerEvent["unique_id"],
    number: "",
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: callFlow.ticker.eventsMap["CUSTOMER_ANSWER"]["unique_id"] + "@@c2c",
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };
};

export const getApiParamsLegCHold = (callFlow, agent) => {
  return {
    uuid: ((sessionStorage.getItem('legcuuid') && callFlow.ticker.eventsMap["CUSTOMER_ANSWER"]["unique_id"]) || callFlow.state.agentAnswerEvent["Other_Leg_Unique_ID"]),
    number: "",
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: (sessionStorage.getItem('legcuuid') || callFlow.ticker.agentAnswerEvent["unique_id"]) + "@@c2c",
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };
};

export const getApiParamsCancel = (callFlow, agent) => {
  return {
    uuid: sessionStorage.getItem('legcuuid'),
    number: getAgentPhoneForCalling(agent),
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: sessionStorage.getItem('legcuuid') + "@@c2c",
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };
};

export const getApiParamsForTransfer = (callFlow, agent) => {
  const data = {
    user_id: getCallSessionAgentUserId(),
    cm_access_key: null,
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],

    uuid: callFlow.ticker.agentAnswerEvent["unique_id"],
    ivr_display_number: callFlow.state.callEvent["knowlarity_number"],
    to: getAgentPhoneForCallingKrmId(agent),
    queue_id: callFlow.state.callEvent["variable_cc_queue"]
      ? callFlow.state.callEvent["variable_cc_queue"]
      : null,
  };

  return data;
};

export const c2c = {
  CALL_ACTIONS: {
    TRANSFER_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "att_xfer";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_conference/conference_call/",
        "POST",
        data
      );
      return response;
    },

    CONFERENCE_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "att_conf";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_conference/conference_call/",
        "POST",
        data
      );
      return response;
    },

    CONFERENCE_CALL_CANCEL: async (callFlow, agent) => {
      const data1 = getApiParamsCancel(callFlow, agent);
      data1["type"] = "conference_kick";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      return await callAPi(
        "/newsr/sr_conference/conference_call/",
        "POST",
        data
      );
    },

    CONFERENCE_HOLD: async (callFlow, agent) => {
      if (
        (callFlow.state.call_type !== "legc_call" &&
          !callFlow.ticker.is_bdtmf)
      ) {
        const data1 = getApiParamsForTransfer(callFlow, agent);
        data1["type"] = "hold";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        const response = await callAPi(
          "/newsr/sr_callcenter/transfer_call/",
          "POST",
          data
        );
        return response;
      } else {
        const data1 = getApiParamsHold(callFlow, agent);
        data1["type"] = "conference_hold";
        data1["number"] = "";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        return await callAPi(
          "/newsr/sr_conference/conference_call/",
          "POST",
          data
        );
      }
    },
    CONFERENCE_UNHOLD: async (callFlow, agent) => {
      if (
        (callFlow.state.call_type !== "legc_call" &&
          !callFlow.ticker.is_bdtmf)
      ) {
        const data1 = getApiParamsForTransfer(callFlow, agent);
        data1["type"] = "unhold";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        const response = await callAPi(
          "/newsr/sr_callcenter/transfer_call/",
          "POST",
          data
        );
        return response;
      } else {
        const data1 = getApiParamsHold(callFlow, agent);
        data1["type"] = "conference_unhold";
        data1["number"] = "";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        return await callAPi(
          "/newsr/sr_conference/conference_call/",
          "POST",
          data
        );
      }
    },
    AGENT_LIST_API: async (callFlow, params) => {
      return await callAPi("/newsr/api/v1/warm_call_agents/", "GET", params);
    },
  },
};
